import { isActionCurrent } from '@/_core/fluxstore/dispatchOwnership';
import { SaveNewActivity, SaveNewSubtask, SaveNewTask } from '../../../store/actions';

import * as storymapStoreModule from '../../../store';
import { AddNewActivity, AddNewSubtask, AddNewTask, CardType } from '..';
import { getCardType } from './use';
import { getCardById, isActivity, isSubtask, isTask } from '../../../store/use';
import { uuid } from '@/_core/utils/uuid';
import { BoardUserActivityType } from '@/api/workspaceSettings/queries';

import { createDebugger } from '@/_core/utils/debug';
const debug = createDebugger('pages:main:storymap:api:commands:factory:createNewCardCommand');

export const createNewCardCommand = async (action: SaveNewActivity | SaveNewSubtask | SaveNewTask) => {
    debug('createNewCardCommand start', action);
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = getCardById(action.cardId);
    const cardType = getCardType(card);

    const activityId = await uuid.create();
    if (!isActionCurrent(action)) return null;

    const boardActivity: any = {
        CardId: card.id,
        CardName: action.title,
        Datetime: new Date().toJSON(),
        CardDescription: '',
        EstimationUnit: '',
        OriginalContent: card.title,
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: getBoardActivityType(cardType),
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
        Position: card.order,
    };

    let cmd: AddNewTask | AddNewSubtask | AddNewActivity;

    if (isSubtask(card)) {
        cmd = new AddNewSubtask(
            card.id,
            state.id,
            action.title,
            (action as SaveNewSubtask).description ?? card.description,
            card.order,
            card.taskId,
            card.releaseId,
            state.subtaskColor
        );

        const task = state.tasks.find((x) => x.id === card.taskId);
        const release = state.releases.find((x) => x.id === card.releaseId);

        boardActivity.ParentCardId = card.taskId;
        boardActivity.ParentCardName = task.title;
        boardActivity.ReleaseId = card.releaseId;
        boardActivity.ReleaseName = release.name;
    }

    if (isTask(card)) {
        cmd = new AddNewTask(card.id, state.id, action.title, card.description, card.order, card.activityId, state.taskColor);

        const activity = state.activities.find((x) => x.id === card.activityId);

        boardActivity.ParentCardId = card.activityId;
        boardActivity.ParentCardName = activity.title;
    }

    if (isActivity(card)) {
        cmd = new AddNewActivity(card.id, state.id, action.title, card.description, card.order, state.activityColor);
    }

    cmd.BoardActivity = boardActivity;

    debug('createNewCardCommand end', cmd);
    return cmd;
};

const getBoardActivityType = (cardType: CardType) => {
    switch (cardType) {
        case CardType.Activity:
            return BoardUserActivityType.ActivityCreated;
        case CardType.Task:
            return BoardUserActivityType.TaskCreated;
        case CardType.Subtask:
            return BoardUserActivityType.SubtaskCreated;
        case CardType.UnscheduledSubtask:
            return BoardUserActivityType.UnscheduledSubtaskCreated;
    }
};
